exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".activeWatchlistsTable {\n  max-width: 100%;\n}\n.activeWatchlistsTable tbody td {\n    max-width: 162px;\n    white-space: break-spaces;\n}\n", ""]);

